"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { customElement, property, state, query } from "lit/decorators.js";
import { hideSupportChat } from "../../hideSupportChat";
import { STCComponentMixin } from "../../common/mixins/stc_component_mixin";
export let ReportFinderKnowledgeBot = class extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.privacyStatement = "";
    this.greeting = "";
    this.protocol = "";
    this.baseUrl = "";
    this.applicationType = "STC";
    this.chatId = "1";
    this.inputSuffix = "";
    this.isDrawerOpen = false;
    this.linkProcessedAttribute = "data-ai-rpt-link-processed";
    this.regex = new RegExp(`\\?ai=1">`, "g");
    this.blockquoteRegex = new RegExp(`</?blockquote>`, "g");
  }
  __handleLinkClick(event) {
    event.preventDefault();
    const messages = this.knowledgeBot?.bot?.messages?.messages?.slice(2) || [];
    let conversationText = "";
    messages.forEach((obj) => {
      if (obj.raw) {
        conversationText += obj.type === "from-bot" ? "Chatbot: " : "Human: ";
        conversationText += `${obj.raw}
`;
      }
    });
    localStorage["ai_report_finder_context"] = conversationText;
    const a = document.createElement("a");
    a.href = event.target.href;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  handlePreviewClick() {
    this.isDrawerOpen = true;
  }
  __addLinkListeners() {
    if (!this.isDrawerOpen || !this.knowledgeBot || !this.knowledgeBot.shadowRoot) {
      return;
    }
    const linkContainer = this.knowledgeBot.shadowRoot;
    linkContainer.querySelectorAll(`a[${this.linkProcessedAttribute}="false"]`).forEach((link) => {
      link.setAttribute(this.linkProcessedAttribute, "true");
      link.addEventListener("click", (e) => this.__handleLinkClick(e));
    });
  }
  updated(changedProperties) {
    if (changedProperties.has("isDrawerOpen") && this.isDrawerOpen) {
      if (this.drawer instanceof HTMLElement) {
        hideSupportChat(this.drawer);
        this.knowledgeBot.bot.pointCut.add("before", "render-message-block", (message) => {
          if (message.type === "from-bot") {
            message.content = message.content.replace(
              this.regex,
              `?ai=1" ${this.linkProcessedAttribute}="false">`
            );
            message.content = message.content.replace(
              this.blockquoteRegex,
              ""
            );
          }
          return message;
        });
        this.knowledgeBot.bot.pointCut.add("after", "message-done", () => {
          this.__addLinkListeners();
        });
      }
    }
    this.__addLinkListeners();
  }
  handleClose() {
    this.isDrawerOpen = false;
  }
  renderKnowledgeBot() {
    if (!this.isDrawerOpen) return "";
    return html`<hi-drawer 
    id="ai-report-finder-drawer"
    heading="AI Report Finder"
    opened
    @close-ended=${this.handleClose}
  >
    <eab-nav-knowledge-bot
      id="report-finder-knowledge-bot"
      image="https://cdn.dev.eab.com/assets/2018-07-11/logo/logo-circle.png"
      heading="Chat with AI Report Finder"
      placeholder="Ask a question"
      .prompts=${[
      { html: this.privacyStatement },
      { html: this.greeting }
    ]}
      uri=${this.protocol}
      .uriFn=${() => `${this.baseUrl}/report_finder?application_type=${this.applicationType}&chat_id=${this.chatId}`}
      .uriSettings=${{
      send: {
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
        }
      }
    }}
    >
    </eab-nav-knowledge-bot>
  </hi-drawer>`;
  }
  render() {
    return html`
      <div class="mb-4 ai_report_finder_button">
        <hi-button 
          id="ai_report_finder_button${this.inputSuffix}"
          aesthetic="secondary"
          aria-label="ai report finder"
          @trigger-ended=${this.handlePreviewClick}
        >
          <hi-icon kind="robot" aria-hidden="true"></hi-icon>
          <span>AI Report Finder</span>
        </hi-button>
      </div>
      ${this.renderKnowledgeBot()}
    `;
  }
};
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "privacyStatement", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "greeting", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "protocol", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "baseUrl", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "applicationType", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "chatId", 2);
__decorateClass([
  property({ type: String })
], ReportFinderKnowledgeBot.prototype, "inputSuffix", 2);
__decorateClass([
  state()
], ReportFinderKnowledgeBot.prototype, "isDrawerOpen", 2);
__decorateClass([
  query("#ai-report-finder-drawer")
], ReportFinderKnowledgeBot.prototype, "drawer", 2);
__decorateClass([
  query("#report-finder-knowledge-bot")
], ReportFinderKnowledgeBot.prototype, "knowledgeBot", 2);
ReportFinderKnowledgeBot = __decorateClass([
  customElement("stc-report-finder-knowledge-bot")
], ReportFinderKnowledgeBot);
